export const environment = {
    production: false,
    url: "https://api-ashleyfurniture.policystreet.app/api",
};
